import { render, staticRenderFns } from "./PromotionPage.vue?vue&type=template&id=a21a6a0e"
import script from "./PromotionPage.vue?vue&type=script&lang=js"
export * from "./PromotionPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports